// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('resellerorder', {
        url: '/resellerorder',
        parent: 'main',
        abstract: true,
        templateUrl: 'main/resellerorder/resellerorder.tpl.html',
        controller: 'MainResellerOrderController as vm'
    });
}

// @ngInject
function MainResellerOrderController() {
    //var vm = this;
}

angular
    .module('main.resellerorder', [
        'resellerorder.api',
        'resellerorder.resellerordersearch',
        'resellerorder.resellerordercreate',
        'resellerorder.resellerreturnordercreate',
        'resellerorder.resellerreturnordermodify',
        'resellerorder.resellerordermodify',
        'resellerorder.createfulfillment',
        'resellerorder.manageorders',
        'resellerorder.manageproducts',
        'resellerorder.resellerorderview'
    ])
    .config(stateConfig)
    .controller('MainResellerOrderController', MainResellerOrderController);
